import Decimal from 'decimal.js';
export function sumCredits(credits) {
  return credits.filter(c => !c.isPaused).reduce((a, b) => a.plus(b.totalAmount), new Decimal(0)).abs();
}